
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"center"}}>
            <strong >Reteinerid</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
            <h4 style={{ color: "#43ACE7", fontWeight: "500" }}>
        Hoidke oma kaunist naeratust
      </h4>
      <p>
        Peale ortodontilise ravi lõppu on oluline säilitada saavutatud tulemusi. Hammaste retensioon ehk ravitulemuse püsiv hoidmine on protsess, mis aitab vältida hammaste tagasiliikumist ja säilitada õiget hammaste asendit pikema aja vältel. Selleks kasutatakse spetsiaalseid retensiooniseadmeid, nagu näiteks öösel kantavad öökaped-reteinerid või õhukesed traadid, mis on paigaldatud hammaste tagaküljele. Õige retensioonirežiimi järgimine aitab tagada, et teie naeratus jääb kauniks ja terved hambad püsivad õiges asendis aastaid.  
      </p>
      Pakume saavutatud tulemuse hoidmiseks erinevaid  reteinereid:
      <ul>
        <li>
          Essix reteiner- individuaalselt valmistatud vaakumreteiner, mis valmib hambalaboris hambatehniku käe all.
        </li>
        <li>
          <a href='https://www.invisalign.com/vivera-retainers'>Vivera™  Retainers </a> – läbipaistvad, vastupidavad ja individuaalselt valmistatud reteinerid, mis aitavad hoida ortodontilise ravi tulemuse stabiilsena ja naeratuse kaunina.
        </li>
        <li>
          Fikseeritud reteiner – hammaste siseküljele kinnitatav õhuke traat, mis hoiab hambad püsivalt õiges asendis ja aitab vältida nende tagasi liikumist pärast ortodontilist ravi.
        </li>
      </ul>
      </Container>
          </Container>

        </div>
    );
}